import * as UserEvents from 'redux/api/internal/UserEvents'
import { GlobalFilterVariant } from 'types/GlobalGlobalFilter'
import { Action } from 'types/GlobalUserEvents'
import { getContextFromPath } from 'utils/contextPaths'

export const logGlobalFilterActivated = (
  variant: GlobalFilterVariant,
  history: any
) => {
  let action = Action.ACTIVATE_GLOBAL_FILTER_CUSTOM

  if (variant === GlobalFilterVariant.ALL) {
    action = Action.ACTIVATE_GLOBAL_FILTER_ALL
  } else if (variant === GlobalFilterVariant.STANDARD) {
    action = Action.ACTIVATE_GLOBAL_FILTER_STANDARD
  }

  UserEvents.log({
    action: action,
    context: getContextFromPath(history.location.pathname),
    dashboard_id: null,
    dashboard_group_id: null
  })
}
